import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import ConnectGmailModal from '../components/ConnectGmailModal';

export interface ConnectGmailModalContextValue {
    isOpen: boolean;
    openModal: () => void;
    closeModal: () => void;
}

const ConnectGmailModalContext = createContext<ConnectGmailModalContextValue | null>(null);

export function ConnectGmailModalProvider({ children }: { children: React.ReactNode }) {
    const [isOpen, setIsOpen] = useState(false);
    const openModal = useCallback(() => setIsOpen(true), []);
    const closeModal = useCallback(() => setIsOpen(false), []);

    const value = useMemo(
        () => ({ isOpen, openModal, closeModal }),
        [isOpen, openModal, closeModal],
    );

    return (
        <ConnectGmailModalContext.Provider value={value}>
            {children}
            <ConnectGmailModal isOpen={isOpen} onClose={closeModal} />
        </ConnectGmailModalContext.Provider>
    );
}

export function useConnectGmailModal(): ConnectGmailModalContextValue {
    const ctx = useContext(ConnectGmailModalContext);
    if (!ctx) {
        throw new Error('useConnectGmailModal must be used within ConnectGmailModalProvider');
    }
    return ctx;
}
